import Icon from '@/components/ui/AppIcon';

interface Feature {
  name: string;
  web: boolean;
  mobile: boolean;
  description: string;
}

const FeaturesComparison = () => {
  const features: Feature[] = [
    {
      name: "Live Trading Signals",
      web: true,
      mobile: true,
      description: "Real-time AI-driven signals for crypto and forex markets"
    },
    {
      name: "Push Notifications",
      web: false,
      mobile: true,
      description: "Instant alerts for new signals and market opportunities"
    },
    {
      name: "Paper Trading",
      web: false,
      mobile: true,
      description: "Practice with virtual money before risking real capital"
    },
    {
      name: "Performance Analytics",
      web: true,
      mobile: true,
      description: "Track your trading performance and win rates"
    },
    {
      name: "Offline Access",
      web: false,
      mobile: true,
      description: "View saved signals and data without internet connection"
    },
    {
      name: "Biometric Security",
      web: false,
      mobile: true,
      description: "Face ID and fingerprint authentication for secure access"
    },
    {
      name: "Community Chat",
      web: true,
      mobile: true,
      description: "Connect with other traders and share insights"
    },
    {
      name: "Widget Support",
      web: false,
      mobile: true,
      description: "Quick access to signals from your home screen"
    }
  ];

  return (
    <section className="py-20 px-4 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            Mobile App vs Web Experience
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Get the full Signaly experience with our mobile app featuring exclusive capabilities
          </p>
        </div>

        <div className="bg-card border border-border rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border">
                  <th className="text-left px-6 py-4 text-foreground font-heading font-semibold">Feature</th>
                  <th className="text-center px-6 py-4 text-foreground font-heading font-semibold">Web</th>
                  <th className="text-center px-6 py-4 text-foreground font-heading font-semibold">Mobile App</th>
                </tr>
              </thead>
              <tbody>
                {features.map((feature, index) => (
                  <tr key={index} className="border-b border-border last:border-b-0 hover:bg-muted/50 transition-colors duration-200">
                    <td className="px-6 py-4">
                      <div>
                        <div className="text-foreground font-medium mb-1">{feature.name}</div>
                        <div className="text-sm text-muted-foreground">{feature.description}</div>
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center">
                      {feature.web ? (
                        <Icon name="CheckCircleIcon" size={24} className="text-success mx-auto" />
                      ) : (
                        <Icon name="XCircleIcon" size={24} className="text-muted-foreground mx-auto" />
                      )}
                    </td>
                    <td className="px-6 py-4 text-center">
                      {feature.mobile ? (
                        <Icon name="CheckCircleIcon" size={24} className="text-primary mx-auto" />
                      ) : (
                        <Icon name="XCircleIcon" size={24} className="text-muted-foreground mx-auto" />
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-2 px-6 py-3 bg-primary/10 border border-primary/20 rounded-full">
            <Icon name="SparklesIcon" size={20} className="text-primary" />
            <span className="text-sm font-medium text-primary">Mobile app includes all web features plus exclusive mobile-only capabilities</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesComparison;